import React from "react";
import * as Yup from "yup";
import { useFormikContext, Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import { Trash2} from "react-feather";
import { Flag } from "react-feather";
import getOnboardingStages from "../../utils/onboardingStages";
import Spinner from 'react-bootstrap/Spinner';

const { REACT_APP_BACKEND_URL } = process.env;


const AddPastHospitalPrivilegesButton = () => {
  const { values, setFieldValue } = useFormikContext();

  const handleAddClicked = (e) =>
  {
      e.preventDefault();
      setFieldValue("pastHospitalPrivileges", [
        ...values.pastHospitalPrivileges,
        {organization: "", startDate: "", endDate: "", notes: "", document: null, documentFilename: ""},
      ]);
  }

  return (
    <Button onClick={(e) => handleAddClicked(e)} size="sm">+ Add Past Hospital Privileges</Button>
  );
}

const RemovePastHospitalPrivilegesButton = ({index}) => {
  const { values, setFieldValue } = useFormikContext();

  const handleRemoveClicked = (e) =>
  {
      e.preventDefault();
      setFieldValue("pastHospitalPrivileges", values.pastHospitalPrivileges.filter((_, i) => i !== index));
  }

  return (
    <Trash2 style={{'height': '12px', 'width': '12px'}} className="float-end" cursor="pointer" onClick={(e) => {handleRemoveClicked(e)}}/>
  );
}



const OnboardingPastHospitalPrivileges = ({stage, token, data}) => {
  var initialValues = {pastHospitalPrivileges:[]}

  if (data && data.pastHospitalPrivileges)
  {
    for (var i = 0; i < data.pastHospitalPrivileges.length; i++)
    {
      if (data.pastHospitalPrivileges[i].organization == null)
      {
        data.pastHospitalPrivileges[i].organization = "";
      }
      if (data.pastHospitalPrivileges[i].startDate == null)
      {
        data.pastHospitalPrivileges[i].startDate = "";
      }
      if (data.pastHospitalPrivileges[i].endDate == null)
      {
        data.pastHospitalPrivileges[i].endDate = "";
      }
      if (data.pastHospitalPrivileges[i].notes == null)
      {
        data.pastHospitalPrivileges[i].notes = "";
      }
      if (data.pastHospitalPrivileges[i].documentFilename == null)
      {
        data.pastHospitalPrivileges[i].documentFilename = "";
      }

      data.pastHospitalPrivileges[i].document = null;


      initialValues.pastHospitalPrivileges.push(data.pastHospitalPrivileges[i]);
    }
  }

  // for (i=initialValues.pastHospitalPrivileges.length; i < 1; i++)
  // {
  //   initialValues.pastHospitalPrivileges.push({organization: "", startDate: "", endDate: "", notes: "", document: null, documentFilename: ""});
  // }

  let onboardingStages = getOnboardingStages(data.preferences);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        pastHospitalPrivileges: Yup.array().of(
          Yup.object().shape({
            organization: Yup.string().max(255).required("Organization is required"),
            startDate: Yup.date().required("Start date is required"),
            endDate: Yup.date(),
            notes: Yup.string().max(2047).required("Contact information is required"),
            documentFilename: Yup.string(),
            document: Yup.mixed().when("documentFilename", {
              is: value => !value || value === "",
              then: Yup.mixed().required("Document is required"),
              otherwise: Yup.mixed()
            })
          })
        )
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          for (var i = 0; i < values.pastHospitalPrivileges.length; i++)
          {
            // Set the document filename to the file we're sending so we can link the two up on the backend; preserve the old, if any, so we can delete
            values.pastHospitalPrivileges[i].oldDocumentFilename = values.pastHospitalPrivileges[i].documentFilename;
            if (values.pastHospitalPrivileges[i].document !== null)
            {
              values.pastHospitalPrivileges[i].documentFilename = values.pastHospitalPrivileges[i].document.name;
            }
          }

          var formData = new FormData();
          formData.append("data", new Blob([JSON.stringify(
            {
              pastHospitalPrivileges: values.pastHospitalPrivileges
            })], {
              type: "application/json"
          }));

          for (i = 0; i < values.pastHospitalPrivileges.length; i++)
          {
            if (values.pastHospitalPrivileges[i].document !== null)
            {
              formData.append("files", values.pastHospitalPrivileges[i].document);
            }
          }

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "onboarding/" + stage + "/" + token, requestMetadata);

          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) + 1] + "/" + token
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        status,
        touched,
        values,
        getFieldProps,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Past Hospital Privileges
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Please include all past hospital privileges.</span>
            </Form.Label><br />
            {values.pastHospitalPrivileges.map((pastHospitalPrivileges, index) => (
                <div key={index}>
                <i>#{index +1}</i>
                <RemovePastHospitalPrivilegesButton index={index} />
                
                <br />
                <Form.Control
                  placeholder="Name of Facility"
                  {...getFieldProps(`pastHospitalPrivileges[${index}].organization`)}
                  isInvalid={Boolean(touched.pastHospitalPrivileges?.[index]?.organization && errors.pastHospitalPrivileges?.[index]?.organization)}
                />
                {!!touched.pastHospitalPrivileges?.[index]?.organization && (
                  <Form.Control.Feedback type="invalid">
                    {errors.pastHospitalPrivileges?.[index]?.organization}
                  </Form.Control.Feedback>
                )}
                <br />
                <Form.Label style={{fontSize: "0.9em"}}>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  {...getFieldProps(`pastHospitalPrivileges[${index}].startDate`)} 
                  isInvalid={Boolean(touched.pastHospitalPrivileges?.[index]?.startDate && errors.pastHospitalPrivileges?.[index]?.startDate)}
                />
                {!!touched.pastHospitalPrivileges?.[index]?.startDate && (
                  <Form.Control.Feedback type="invalid">
                    {errors.pastHospitalPrivileges?.[index]?.startDate}
                  </Form.Control.Feedback>
                )}
                <br />
                <Form.Label style={{fontSize: "0.9em"}}>End Date</Form.Label>
                <Form.Control
                  type="date"
                  {...getFieldProps(`pastHospitalPrivileges[${index}].endDate`)} 
                  isInvalid={Boolean(touched.pastHospitalPrivileges?.[index]?.endDate && errors.pastHospitalPrivileges?.[index]?.endDate)}
                />
                {!!touched.pastHospitalPrivileges?.[index]?.endDate && (
                  <Form.Control.Feedback type="invalid">
                    {errors.pastHospitalPrivileges?.[index]?.endDate}
                  </Form.Control.Feedback>
                )}
                <br />
                <Form.Control
                  as="textarea"
                  style={{height: "100px"}}
                  placeholder="Complete facility contact information (including address, phone, fax, and email address), *as well as* point of contact"
                  {...getFieldProps(`pastHospitalPrivileges[${index}].notes`)}
                  isInvalid={Boolean(touched.pastHospitalPrivileges?.[index]?.notes && errors.pastHospitalPrivileges?.[index]?.notes)}
                />
                {!!touched.pastHospitalPrivileges?.[index]?.notes && (
                  <Form.Control.Feedback type="invalid">
                    {errors.pastHospitalPrivileges?.[index]?.notes}
                  </Form.Control.Feedback>
                )}
                <br />
                <Form.Label style={{fontSize: "0.9em"}}>DOP</Form.Label>
                {values.pastHospitalPrivileges?.[index]?.documentFilename && 
                <Form.Label>(Current: <span style={{wordBreak: "break-all"}}>{values.pastHospitalPrivileges?.[index]?.documentFilename}</span>)</Form.Label>
                }
                <Form.Control
                  type="hidden"
                  {...getFieldProps(`pastHospitalPrivileges[${index}].documentFilename`)}
                />
                <Form.Control
                  type="file"
                  name={`pastHospitalPrivileges[${index}].document`}
                  onBlur={handleBlur}
                  onChange={(event) => {
                    const file = event.currentTarget.files.length > 0 ? event.currentTarget.files[0] : null;
                    setFieldValue(`pastHospitalPrivileges[${index}].document`, file);
                  }}
                  isInvalid={Boolean(touched.pastHospitalPrivileges?.[index]?.document && errors.pastHospitalPrivileges?.[index]?.document)}
                />
                {!!touched.pastHospitalPrivileges?.[index]?.document && (
                  <Form.Control.Feedback type="invalid">
                    {errors.pastHospitalPrivileges?.[index]?.document}
                  </Form.Control.Feedback>
                )}
                <br />
                </div>
            ))}
            <AddPastHospitalPrivilegesButton />
          </Form.Group>
          <br />
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
            <div className="text-center mt-3 float-start">
              <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
            </div>
            <div id="submitButton" className="text-center mt-3 float-end">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}  // Don't check touched, otherwise you end up with this button disabled for, e.g. a peer reference first name missing that has never been touched, so it's not in red; let them click this to touch everything
              >
                Save and Continue
              </Button>
            </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before moving forward</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default OnboardingPastHospitalPrivileges;
